import { RESET_APP_ERRORS } from './constants';

export const resetErrorMessage = () => ({
    type: RESET_APP_ERRORS
});


// WEBPACK FOOTER //
// ./src/models/application/actions.js